<script>
import EmptyListIndicatorComponent from 'frontend/roles/components/EmptyListIndicatorComponent.vue'
import EmptyGoalIcon from 'frontend/session/assets/empty-goal-icon.vue'
import { inject, ref } from 'vue'

export default {
  name: 'DataTableNothingFound',
  setup() {
    const nothingFoundCellRef = ref(null)
    const tableHeight = inject('tableHeight')
    const isModalFullScreen = inject('isModalFullScreen', false)
    const inModal = inject('inModal', false)
    const searchPerformed = inject('searchPerformed', false)
    return {
      tableHeight,
      isModalFullScreen,
      nothingFoundCellRef,
      inModal,
      searchPerformed,
    }
  },
  computed: {
    teleportTo() {
      return this.nothingFoundCellRef?.offsetParent?.parentElement
    },
  },
  components: { EmptyGoalIcon, EmptyListIndicatorComponent },
}
</script>

<template lang="pug">
tr.disable-sticky-actions
  td.nothing-found-cell(
    ref="nothingFoundCellRef"
    :style="{ height: inModal ? 0 : null }"
    colspan="2000"
  )
    teleport(:disabled="!teleportTo" :to="teleportTo")
      .nothing-found-container.d-flex.align-items-center.justify-content-center
        empty-list-indicator-component
          template(#title) No records found
          template(#before)
            empty-goal-icon
          template(#description)
            .d-block(v-if="searchPerformed") Try to change your search criteria.
            .d-block(v-else) or they are out of your access scope
</template>

<style scoped lang="scss">
.nothing-found-container {
  height: calc(100% - 38px);

  .empty-list-indicator {
    gap: 0;
  }
}
</style>
